export * from "/codebuild/output/src4215440485/src/git-codecommit.eu-west-2.amazonaws.com/v1/repos/vl-app/vl-common/wrapped-antd/index.ts"